import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import AppointmentPage from "./pages/AppointmentsPage";
import StaffPage from "./pages/StaffPage";
import AddAppointmentPage from "./pages/AddAppointmentPage";
import AddStaffPage from "./pages/AddStaffPage";
import AddStockPage from "./pages/AddStockPage";
import ViewAppointmentPage from "./pages/ViewAppointmentPage";
import EditAppointmentPage from "./pages/EditAppointmentPage";
import AssignAppointmentPage from "./pages/AssignAppointmentPage";
import StockListPage from "./pages/StockListPage";
import ViewStockPage from "./pages/ViewStockPage";
import EditStockPage from "./pages/EditStockPage";
import CustomerPage from "./pages/CustomerPage";
import AppointmentStatusPage from "./pages/AppointmentStatusPage";
import AddCompanyPage from "./components/AddCompanyPage";
import ViewCustomerPage from "./components/ViewCustomerPage";
import EditCustomerPage from "./components/EditCustomerPage";
import ViewStaffPage from "./components/ViewStaffPage";
import InvoiceListStatusPage from "./pages/InvoiceListStatusPage";
import QuoteAddPage from "./pages/QuoteAddPage";
import QuoteListPage from "./pages/QuoteListPage";
import QuoteEditPage from "./pages/QuoteEditPage";
import QuotePreviewPage from "./pages/QuotePreviewPage";
import AddPolicyPage from "./components/AddPolicyPage";
import EditPolicyPage from "./components/EditPolicyPage";
import AddServicePage from "./pages/AddServicePage";
import ServiceListPage from "./pages/ServiceListPage";
import ViewServicePage from "./pages/ViewServicePage";
import EditServicePage from "./pages/EditServicePage";
import JobInvoicePreviewPage from "./pages/JobInvoicePreviewPage";
import AddWorkForcePage from "./pages/AddWorkForcePage";
import WorkForcePage from "./pages/WorkForcePage";
import EditAddWorkForcePage from "./pages/EditAddWorkForcePage";
import ViewWorkForcePage from "./pages/ViewWorkForcePage";
import ShowReportPage from "./components/ShowReportPage";
import JobInvoicePage from "./pages/JobInvoicePage";
import AccountPage from "./pages/AccountPage";
import InvoicePaymentLog from "./pages/InvoicePaymentLog";
import MyReportingPage from "./pages/MyReportingPage";
import TemplateSelectionPage from "./pages/TemplateSelectionPage";
import ComparisonPage from "./pages/ComparisonPage";
import AddSupplyLayer from "./pages/AddSupplierLayer";
import SupplierListPage from "./pages/SupplierListPage";
import EditSupplierPage from "./pages/EditSupplierPage";
import ViewSupplierLayer from "./components/ViewSupplierLayer";
import ViewSupplierPage from "./pages/ViewSupplierPage";
import AddBillPage from "./pages/AddBillPage";
import AddPaymentPage from "./pages/AddPaymentPage";
import AddPurchaseOrderPage from "./pages/AddPurchaseOrderPage";
import PurchaseOrderListPage from "./pages/PurchaseOrderListPage";
import PurchaseBillListPage from "./pages/PurchaseBillListPage";
import PurchasePaymentListPage from "./pages/PurchasePaymentListPage";
import ViewPurchaseBillPage from "./pages/ViewPurchaseBillPage";
import ViewPurchaseOrderPage from "./pages/ViewPurchaseOrderPage";
import PrintBillPage from "./pages/PrintBillPage";
import AddExpensePage from "./pages/AddExpensepage";
import ExpenseListPage from "./pages/ExpenseListPage";
import ViewExpensePage from "./pages/ViewExpensePage";
import EditExpensePage from "./pages/EditExpensePage";
import LedgerPage from "./pages/LedgerPage";
import SalesReportPage from "./pages/SalesReportPage";
import PurchasePage from "./pages/PurchaseReport";
import ExpenseReportPage from "./pages/ExpensePage";
import ProfitLossReport from "./pages/ProfitLossReport";
import AccountReportPage from "./pages/AccountReport";
import LedgerReportPage from "./pages/LedgerReportPage";
import AddAssetPage from "./pages/AddAssetPage";
import AssetsListPage from "./pages/AssetsListPage";
import EditAssetPage from "./pages/EditAssetPage";
import ViewAssetPage from "./pages/ViewAssetPage";
import AssetReport from "./pages/AssetReport";
import AddCustomerPage from "./pages/AddCustomerPage";
import ExpenseCategoryPage from "./pages/ExpenseCategoryPage";
import UomPage from "./pages/UomPage";
import ColorPage from "./pages/ColorPage";
import CityPage from "./pages/CityPage";
import AccountLogsPage from "./pages/AccountLogsPage";


function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route exact path="/" element={<HomePageTwo/>} />
        <Route exact path="/jobs" element={<AppointmentPage/>} />
        <Route exact path="/jobs/:status" element={<AppointmentStatusPage/>} />
        <Route exact path="/add-job" element={<AddAppointmentPage/>} />
        <Route exact path="/create-job-invoice/:id" element={<JobInvoicePage/>} />
        <Route exact path="/view-report/:id" element={<ShowReportPage/>} />
        <Route exact path="/assign-job" element={<AssignAppointmentPage/>} />
        <Route exact path="/view-job/:id" element={<ViewAppointmentPage/>} />
        <Route exact path="/edit-job/:id" element={<EditAppointmentPage/>} />
        <Route exact path="/view-invoice-job/:job_id" element={<JobInvoicePreviewPage/>} />
        <Route exact path="/staff" element={<StaffPage/>} />
        <Route exact path="/staff/view/:id" element={<ViewStaffPage/>} />
        <Route exact path="/customer" element={<CustomerPage/>} />
        <Route exact path="/customer/view/:id" element={<ViewCustomerPage/>} />
        <Route exact path="/customer/edit/:id" element={<EditCustomerPage/>} />
        <Route exact path="/add-staff" element={<AddStaffPage/>} />
        <Route exact path="/add-service" element={<AddServicePage/>} />
        <Route exact path="/services" element={<ServiceListPage/>} />
        <Route exact path="/view-service/:id" element={<ViewServicePage/>} />
        <Route exact path="/add-stock" element={<AddStockPage/>} />
        <Route exact path="/stock-list" element={<StockListPage/>} />
        <Route exact path="/view-stock/:id" element={<ViewStockPage/>} />
        <Route exact path="/edit-stock/:id" element={<EditStockPage/>} />
        <Route exact path="/edit-service/:id" element={<EditServicePage/>} />
        <Route exact path="/company" element={<AddCompanyPage/>} />
        <Route exact path="/add-workforce" element={<AddWorkForcePage/>} />
        <Route exact path="/workforce" element={<WorkForcePage/>} />
        <Route exact path="/edit-workforce/:id" element={<EditAddWorkForcePage/>} />
        <Route exact path="/view-workforce/:id" element={<ViewWorkForcePage/>} />
        <Route exact path="/comparison" element={<ComparisonPage/>} />
        <Route exact path="/supplier" element={<AddSupplyLayer/>} />
        <Route exact path="/list-supplier" element={<SupplierListPage/>} />
        <Route exact path="/edit-supplier/:id" element={<EditSupplierPage/>} />
        <Route exact path="/view-supplier/:id" element={<ViewSupplierPage/>} />
        <Route exact path="/list-po" element={<PurchaseOrderListPage/>} />
        <Route exact path="/list-bills" element={<PurchaseBillListPage/>} />
        <Route exact path="/list-payments" element={<PurchasePaymentListPage/>} />
        <Route exact path="/view-bill/:id" element={<ViewPurchaseBillPage/>} />
        <Route exact path="/view-po/:id" element={<ViewPurchaseOrderPage/>} />
        <Route exact path="/print-bill/:id" element={<PrintBillPage/>} />
        <Route exact path="/addexpense" element={<AddExpensePage/>} />
        <Route exact path="/list-expense" element={<ExpenseListPage/>} />
        <Route exact path="/view-expense/:id" element={<ViewExpensePage/>} />
        <Route exact path="/edit-expense/:id" element={<EditExpensePage/>} />
        <Route exact path="/ledger" element={<LedgerPage/>} />
        <Route exact path="/add-asset" element={<AddAssetPage/>} />
        <Route exact path="/list-asset" element={<AssetsListPage/>} />
        <Route exact path="/edit-asset/:id" element={<EditAssetPage/>} />
        <Route exact path="/view-asset/:id" element={<ViewAssetPage/>} />

        <Route exact path="/index-2" element={<HomePageTwo />} />
        <Route exact path="/index-3" element={<HomePageThree />} />
        <Route exact path="/index-4" element={<HomePageFour />} />
        <Route exact path="/index-5" element={<HomePageFive />} />
        <Route exact path="/index-6" element={<HomePageSix />} />
        <Route exact path="/index-7" element={<HomePageSeven />} />
        <Route exact path="/add-bill" element={<AddBillPage/>} />
        <Route exact path="/add-payment" element={<AddPaymentPage/>} />
        <Route exact path="/add-po" element={<AddPurchaseOrderPage/>} />


        {/* SL */}
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/alert" element={<AlertPage />} />
        <Route exact path="/assign-role" element={<AssignRolePage />} />
        <Route exact path="/avatar" element={<AvatarPage />} />
        <Route exact path="/badges" element={<BadgesPage />} />
        <Route exact path="/button" element={<ButtonPage />} />
        <Route exact path="/calendar-main" element={<CalendarMainPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/card" element={<CardPage />} />
        <Route exact path="/carousel" element={<CarouselPage />} />
        <Route exact path="/chat-empty" element={<ChatEmptyPage />} />
        <Route exact path="/chat-message" element={<ChatMessagePage />} />
        <Route exact path="/chat-profile" element={<ChatProfilePage />} />
        <Route exact path="/code-generator" element={<CodeGeneratorPage />} />
        <Route exact path="/code-generator-new" element={<CodeGeneratorNewPage />} />
        <Route exact path="/colors" element={<ColorsPage />} />
        <Route exact path="/column-chart" element={<ColumnChartPage />} />
        <Route exact path="/company" element={<CompanyPage />} />
        <Route exact path="/currencies" element={<CurrenciesPage />} />
        <Route exact path="/dropdown" element={<DropdownPage />} />
        <Route exact path="/email" element={<EmailPage />} />
        <Route exact path="/faq" element={<FaqPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/form-layout" element={<FormLayoutPage />} />
        <Route exact path="/form-validation" element={<FormValidationPage />} />
        <Route exact path="/form" element={<FormPage />} />
        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/image-generator" element={<ImageGeneratorPage />} />
        <Route exact path="/image-upload" element={<ImageUploadPage />} />
        <Route exact path="/report" element={<MyReportingPage />} />
        <Route exact path="/sales" element={<SalesReportPage />} />
        <Route exact path="/purchase" element={<PurchasePage />} />
        <Route exact path="/expense" element={<ExpenseReportPage />} />
        <Route exact path="/profitloss" element={<ProfitLossReport />} />
        <Route exact path="/accountReport" element={<AccountReportPage />} />
        <Route exact path="/ledgerReport" element={<LedgerReportPage />} />
        <Route exact path="/assetReport" element={<AssetReport />} />
        <Route exact path="/select-template" element={<TemplateSelectionPage />} />
        <Route exact path="/create-invoice" element={<InvoiceAddPage />} />
        <Route exact path="/create-order-form" element={<InvoiceAddPage />} />
        <Route exact path="/invoice-edit/:id" element={<InvoiceEditPage />} />
        <Route exact path="/order-form-edit/:id" element={<InvoiceEditPage />} />
        <Route exact path="/invoice-payments/:invoiceId" element={<InvoicePaymentLog />} />
        <Route exact path="/order-form-payments/:invoiceId" element={<InvoicePaymentLog />} />
        <Route exact path="/quote-edit/:id" element={<QuoteEditPage />} />
        <Route exact path="/invoices" element={<InvoiceListPage />} />
        <Route exact path="/order-forms" element={<InvoiceListPage />} />
        <Route exact path="/quotes" element={<QuoteListPage />} />
        <Route exact path="/create-quote" element={<QuoteAddPage />} />
        <Route exact path="/invoices/:status" element={<InvoiceListStatusPage />} />
        <Route exact path="/order-forms/:status" element={<InvoiceListStatusPage />} />
        <Route exact path="/invoice-preview/:id" element={<InvoicePreviewPage />} />
        <Route exact path="/order-form-preview/:id" element={<InvoicePreviewPage />} />
        <Route exact path="/quote-preview/:id" element={<QuotePreviewPage />} />
        <Route exact path="/policies" element={<AddPolicyPage />} />
        <Route exact path="/policies/edit/:id" element={<EditPolicyPage />} />
        <Route exact path="/kanban" element={<KanbanPage />} />
        <Route exact path="/language" element={<LanguagePage />} />
        <Route exact path="/line-chart" element={<LineChartPage />} />
        <Route exact path="/list" element={<ListPage />} />
        <Route exact path="/marketplace-details" element={<MarketplaceDetailsPage />} />
        <Route exact path="/marketplace" element={<MarketplacePage />} />
        <Route exact path="/notification-alert" element={<NotificationAlertPage />} />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        <Route exact path="/terms-condition" element={<TermsConditionPage />} />
        <Route exact path="/text-generator-new" element={<TextGeneratorNewPage />} />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route exact path="/wallet" element={<WalletPage />} />
        <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} />
        <Route exact path="/accounts" element={<AccountPage />} />
        <Route exact path="/add-customer" element={<AddCustomerPage />} />
        <Route exact path="/expense-category" element={<ExpenseCategoryPage />} />
        <Route exact path="/uom" element={<UomPage />} />
        <Route exact path="/color" element={<ColorPage />} />
        <Route exact path="/cities" element={<CityPage />} />
        <Route exact path="/accountlog/:id" element={<AccountLogsPage />} />


        <Route exact path="*" element={<ErrorPage />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;



